import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import {
  IReportFile,
  IReportFileState,
} from "@/store/modules/reportFile/state";

export enum ReportFileMutations {
  SET_ONE = "SET_ONE_REPORT_FILE",
  SET_ALL = "SET_ALL_REPORT_FILE",
  SET_LAZY_DATA = "SET_LAZY_DATA_REPORT_FILE",
}

export const mutations: MutationTree<IReportFileState> = {
  [ReportFileMutations.SET_ONE](state, payload: IReportFile) {
    state.reportFile = payload;
  },
  [ReportFileMutations.SET_ALL](state, payload: IReportFile[]) {
    state.reportFiles = payload;
  },
  [ReportFileMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<IReportFile>
  ) {
    state.dataProvider = payload;
  },
};
